import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { of, Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';

import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import { UserSettingsService } from '@cutting/main/shared/services/user-settings.service';
import { navigation } from '@cutting/navigation/navigation';
import { FuseConfigService } from '@fuse/services/config.service';

@Component({
  selector: 'cutting-vertical-layout-1',
  templateUrl: './layout-1.component.html',
  styleUrls: ['./layout-1.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VerticalLayout1Component implements OnInit, OnDestroy {
  fuseConfig: any;
  navigation: any;
  bannerRedirectLink = '';
  bannerKey = '';

  // Private
  private unsubscribeAll: Subject<any>;

  /**
   * Constructor
   * @param fuseConfigService
   * @param userSettingsService
   */
  constructor(private fuseConfigService: FuseConfigService, private userSettingsService: UserSettingsService) {
    // Set the defaults
    this.navigation = navigation;

    // Set the private defaults
    this.unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    if (LocalStorageManager.client) {
      this.userSettingsService
        .getCuttingSettings()
        .pipe(
          switchMap(settings => {
            if (settings.bannerSettings.showBanner && settings.bannerSettings.key.length > 0) {
              this.bannerRedirectLink = settings.bannerSettings.redirectLink;
              return this.userSettingsService
                .getBannerUrl(settings.bannerSettings.key)
                .pipe(tap(key => (this.bannerKey = key)));
            }
            return of(null);
          }),
          takeUntil(this.unsubscribeAll)
        )
        .subscribe();
    }
    // Subscribe to config changes
    this.fuseConfigService.config.pipe(takeUntil(this.unsubscribeAll)).subscribe((config: any) => {
      this.fuseConfig = config;
    });
  }

  redirectToWebsite(): void {
    window.open(this.bannerRedirectLink, '_blank');
  }
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
